import React from 'react';
import { IconBaseProps } from 'react-icons';
import { FaTrashAlt } from 'react-icons/fa';

const Delete: React.FC<IconBaseProps> = (props) => <FaTrashAlt {...props} />;

export default Delete;
